import { Component, Input, OnDestroy, OnInit, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from '../../user';
import { AuthState } from '../../auth-state';
import { Subscription } from 'rxjs';
import { AbstractForm } from 'src/app/shared/utils/abstract-form';
import { LoggerService } from 'src/app/core/logger/logger.service';

@Component({
  selector: 'app-require-new-password',
  templateUrl: './require-new-password.component.html'
})
export class RequireNewPasswordComponent extends AbstractForm implements OnDestroy {

  _show: boolean;
  submitted: boolean;
  private showStates = [AuthState.REQUIRE_NEW_PASSWORD];
  private user: User = new User();
  @HostBinding('className') className = '';

  messageSubscription:Subscription;
  message = '';

  constructor(
    protected formBuilder: FormBuilder,
    logger: LoggerService,
    protected authService: AuthService) {

      super(formBuilder, logger);
  
      this.messageSubscription = authService.messages$.subscribe(msg => {
        this.message = msg?.msg || '';
      });

  }
  ngOnDestroy(){
    this.messageSubscription.unsubscribe();
  }

  @Input()
  set authState(authState) {
    this._show = this.showStates.filter(item => item === authState.state).length > 0;
    if (authState.user) {
      this.user = authState.user;
    }
    this.className = this._show? 'active' : '';
  }

  buildFormGroup(): FormGroup {
    return this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]]
    });

  }
  updateControls() {}
  updateObject():any {}

  getUser(): User {
    this.user.password = this.getControlValue('password');
    return this.user;
  }

  onSubmit() {

    if(this.formGroup.valid)
      this.authService.completeNewPassword(this.getUser());
  }

  onSignIn() {
    this.authService.changeAuthState(AuthState.SIGN_IN, null);
  }
}
